export default "__VITE_ASSET__BWT4rGQs__"